import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { UnitCategoryCode, Fund } from 'funds-model';
import { formatNumber } from '../utils/formatters';
import Decimal from 'decimal.js';
import FundDetailsDialogAccordion from './FundDetailsDialogAccordion';
import { Title } from '../Title/Title';
import { Typography } from '../Typography/Typography';
import { useIsMobile } from '../utils/useIsMobile';
import { Label } from '../Label/Label';

import useStyles from './FundDetailsDialog.style';

export interface FundDetailsDialogCostProps {
  fund: Fund;
  unitCategoryCode: UnitCategoryCode;
}

const FundDetailsDialogCost: React.FC<FundDetailsDialogCostProps> = ({ fund, unitCategoryCode }) => {
  const c = useStyles({});
  const [t] = useTranslation('components');
  const cost = fund.costsForUnitCode[unitCategoryCode];
  const isMobile = useIsMobile();

  if (!cost) {
    return null;
  }

  return (
    <FundDetailsDialogAccordion title={t('fund-details-dialog.cost-sheet.title')}>
      <div>
        {!isMobile && <Title titleComponent="h3" titleVariant="h3" titleFontWeight="bold" title={t('fund-details-dialog.cost-sheet.title')}/>}
        <Typography
          component="p"
          className={c.costInfo}
        >
          {t('fund-details-dialog.cost-sheet.info')}
        </Typography>
        <Grid container className={c.costGrid}>
          <Grid container item direction="column" md={6} className={c.costItem}>
            <Label size="s" color="graphite">{t('fund-details-dialog.cost-sheet.one-time')}</Label>
            <Typography
              component="p"
              className={c.costItemInfo}
            >
              {t('fund-details-dialog.cost-sheet.one-time-text')}
            </Typography>
          </Grid>
          <Grid container item direction="column" md={6} className={c.costItem}>
            <Label size="s" color="graphite">{t('fund-details-dialog.cost-sheet.current')}</Label>
            <Typography
              component="p"
              className={c.costItemInfo}
            >
              {t('fund-details-dialog.cost-sheet.cost', {
                percentage: cost.ongoingChargePercentage.toLocaleString(),
                amount: formatNumber(new Decimal(cost.ongoingChargeAmount)),
              })}
            </Typography>
          </Grid>
          <Grid container item direction="column" md={6} className={c.costItem}>
            <Label size="s" color="graphite">{t('fund-details-dialog.cost-sheet.transaction')}</Label>
            <Typography
              component="p"
              className={c.costItemInfo}
            >
              {t('fund-details-dialog.cost-sheet.cost', {
                percentage: cost.exanteTransactionCostPercentage.toLocaleString(),
                amount: formatNumber(new Decimal(cost.exanteTransactionCostAmount)),
              })}
            </Typography>
          </Grid>
          <Grid container item direction="column" md={6} className={c.costItem}>
            <Label size="s" color="graphite">{t('fund-details-dialog.cost-sheet.additional')}</Label>
            <Typography
              component="p"
              className={c.costItemInfo}
            >
              {t('fund-details-dialog.cost-sheet.additional-text')}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </FundDetailsDialogAccordion>
  );
};

export default FundDetailsDialogCost;
